import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output
} from '@angular/core';
import { AbstractControlValueAccessorComponent } from '../../helpers/abstract-control-value-accessor';
import {
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
  FormControl
} from '@angular/forms';
import { SelectOption } from './options.type';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, NgClass],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true
    }
  ]
})
export class SelectComponent<
  T
> extends AbstractControlValueAccessorComponent<string> {
  @Input() options: SelectOption<T>[] = [];
  @Input() variant: 'default' | 'compact' = 'default'; // Nuevo input para variante
  @Output() selectedOptionChange = new EventEmitter<T>();

  override formControl: FormControl = new FormControl('');

  selectOption(option: Event) {
    const result = option.target as HTMLSelectElement;
    this.selectedOptionChange.emit(result.value as T);
  }
}
